import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../Icon';
import { useI18n } from '../../i18n/I18nContext';
import { useOwnerContact } from '../../hooks/useData';
import { useScrollState } from '../../hooks/useMotion';
import { buildWhatsappHref } from '../../lib/property';
import { MOLINO } from '../../config/molino';

const HIDDEN_ON = [/^\/propiedad\//, /^\/admin/, /^\/contacto/];

function WhatsAppFloat() {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const owner = useOwnerContact();
  const { scrolled } = useScrollState({ scrolledAt: 640 });
  const [footerVisible, setFooterVisible] = useState(false);
  const href = buildWhatsappHref(owner.ownerWhatsapp, pathname === MOLINO.path ? t.projectWaMessage : t.waGeneralMessage);

  useEffect(() => {
    const footer = document.querySelector('.site-footer');
    if (!footer || !('IntersectionObserver' in window)) {
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => setFooterVisible(entry.isIntersecting));
    observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  if (!href || HIDDEN_ON.some((pattern) => pattern.test(pathname))) {
    return null;
  }

  const visible = scrolled && !footerVisible;

  return (
    <a
      className={`wa-float ${visible ? 'is-visible' : ''}`}
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={t.ctaWhatsapp}
      aria-hidden={visible ? undefined : true}
      tabIndex={visible ? 0 : -1}
    >
      <Icon name="whatsapp" size={22} />
      <span className="wa-float__label">{t.ctaWhatsapp}</span>
    </a>
  );
}

export default WhatsAppFloat;
